module.exports = {
  setProduct: (state, obj) => {
    state.data = obj
    if (obj === null) {
      state.mods = []
      state.groupMods = []
      state.choices = []
      state.added = false
      state.isEdit = false
      state.quantity = 1
    }
  },
  setError: (state, bool) => {
    state.error = bool
  },
  setAdded: (state, bool) => {
    state.added = bool
  },
  setQuantity: (state, int) => {
    state.quantity = int
  },
  setMods: (state, arr) => {
    state.mods = arr
  },
  setGroupMods: (state, arr) => {
    state.groupMods = arr
  },
  setChoices: (state, arr) => {
    state.choices = arr
  },
  setInstructions: (state, str) => {
    state.instructions = str
  },
  setRecipient: (state, str) => {
    state.recipient = str
  },
  setFilterOptions: (state, obj) => {
    state.filterOptions = obj
  },
  setIsEdit: (state, bool) => {
    state.isEdit = bool
  },
  setSelectedProd: (state, bool) => {
    state.selected = bool
  },
  // deprecated
  setChoicesFromCart: (state, bool) => {
    state.getChoicesFromCart = bool
  },
}
